<h3 mat-dialog-title>Wyłączenie przekazywania opłat</h3>

<p>
  Po wyłączeniu przekazywania opłat, nowopowstałe opłaty od <b>{{ data.description }}</b> nie zostaną przekazane do
  {{ data.targetEmail }}.
</p>

<p>Czy na pewno chcesz wyłączyć przekazywanie opłat?</p>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true">Wyłącz</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
